import { Wrench, CalendarClock, Euro, Fuel, ShieldAlert, Receipt, Building2, ClipboardList } from "lucide-react";
import { deadlineSeverity } from "../lib/format";

const opt = (arr) => arr.map((v) => ({ value: v, label: v.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase()) }));

export const resources = {
  locations: {resource:'locations', title:'Sedi', icon:Building2, description:'Sedi operative della tua azienda', searchKeys:['name','address'], defaults:{pickup_enabled:true,return_enabled:true},
    columns:[{key:'name',label:'Nome'},{key:'address',label:'Indirizzo'},{key:'phone',label:'Telefono'}],
    fields:[{key:'name',label:'Nome sede',type:'text',required:true},{key:'address',label:'Indirizzo',type:'text'},{key:'phone',label:'Telefono',type:'text'},{key:'email',label:'Email',type:'text'},{key:'opening_hours',label:'Orari',type:'textarea',full:true},{key:'pickup_enabled',label:'Consegna veicoli disponibile',type:'boolean'},{key:'return_enabled',label:'Riconsegna veicoli disponibile',type:'boolean'}]},
  assignments: {
    resource: "assignments",
    title: "Assegnazioni",
    icon: ClipboardList,
    description: "Pianifica chi usa ogni veicolo e per quale periodo. Preventivi e contratti sono in Noleggi; i verbali in Consegne.",
    searchKeys: ["vehicle_plate", "assignee_name", "purpose", "status"],
    columns: [
      { key: "vehicle_plate", label: "Veicolo", type: "plate" },
      { key: "assignee_name", label: "Assegnatario" },
      { key: "start_date", label: "Inizio", type: "date" },
      { key: "end_date_planned", label: "Fine prevista", type: "date" },
      { key: "status", label: "Stato", type: "badge" },
    ],
    defaults: { status: "pianificata", checklist: {} },
    fields: [
      { section: "Veicolo e assegnatario", key: "vehicle_id", label: "Veicolo", type: "ref", refType: "vehicles", required: true },
      { key: "assignee_id", label: "Assegnatario", type: "ref", refType: "assignees", required: true },
      { section: "Periodo", key: "start_date", label: "Data inizio", type: "date", required: true },
      { key: "end_date_planned", label: "Fine prevista", type: "date" },
      { key: "end_date_actual", label: "Riconsegna effettiva", type: "date" },
      { section: "Letture alla consegna e riconsegna", key: "km_start", label: "Km iniziali", type: "number" },
      { key: "km_end", label: "Km finali", type: "number" },
      { key: "fuel_start", label: "Carburante iniziale", type: "text" },
      { key: "fuel_end", label: "Carburante finale", type: "text" },
      { section: "Sedi e condizioni", key: "pickup_site_id", label: "Sede prevista di ritiro", type: "ref", refType: "locations", immutableAfterCreate: true },
      { key: "return_site_id", label: "Sede prevista di riconsegna", type: "ref", refType: "locations" },
      { key: "monthly_fee", label: "Canone mensile (€) — per clienti", type: "currency" },
      { key: "purpose", label: "Finalità", type: "text", full: true },
      { section: "Stato e note", key: "status", label: "Stato", type: "select", options: opt(["pianificata", "in_corso", "in_consegna", "conclusa"]) },
      { key: "checklist", label: "Checklist consegna/riconsegna", type: "checklist", full: true },
      { key: "notes", label: "Note", type: "textarea", full: true },
    ],
  },
  maintenances: {
    resource: "maintenances", title: "Manutenzioni", icon: Wrench,
    description: "Manutenzione ordinaria e straordinaria",
    searchKeys: ["vehicle_plate", "type", "description", "status"],
    columns: [
      { key: "vehicle_plate", label: "Veicolo", type: "plate" },
      { key: "type", label: "Tipo", type: "labelize" },
      { key: "planned_date", label: "Data prevista", type: "date" },
      { key: "status", label: "Stato", type: "badge" },
      { key: "actual_cost", label: "Costo", type: "currency" },
    ],
    defaults: { status: "pianificato" },
    fields: [
      { section: "Intervento", key: "vehicle_id", label: "Veicolo", type: "ref", refType: "vehicles", required: true },
      { key: "type", label: "Tipo intervento", type: "select", required: true, options: opt(["tagliando", "cambio_olio", "pneumatici", "freni", "batteria", "revisione", "guasto", "carrozzeria", "richiamo", "altro"]) },
      { key: "description", label: "Descrizione", type: "text", full: true },
      { key: "supplier_id", label: "Officina / Fornitore", type: "ref", refType: "suppliers" },
      { section: "Date e chilometri", key: "planned_date", label: "Data prevista", type: "date" },
      { key: "opened_date", label: "Data apertura", type: "date" },
      { key: "closed_date", label: "Data chiusura", type: "date" },
      { key: "mileage", label: "Chilometraggio", type: "number" },
      { section: "Costi e stato", key: "estimated_cost", label: "Costo preventivato", type: "currency" },
      { key: "actual_cost", label: "Costo effettivo", type: "currency" },
      { key: "status", label: "Stato", type: "select", options: opt(["pianificato", "da_autorizzare", "autorizzato", "in_lavorazione", "completato", "annullato"]) },
      { section: "Prossimo intervento e note", key: "next_date", label: "Prossimo intervento (data)", type: "date" },
      { key: "next_km", label: "Prossimo intervento (km)", type: "number" },
      { key: "notes", label: "Note", type: "textarea", full: true },
    ],
  },
  deadlines: {
    resource: "deadlines", title: "Scadenze e documenti", icon: CalendarClock,
    description: "Assicurazione, bollo, revisione, contratti e documenti",
    searchKeys: ["vehicle_plate", "category", "number"],
    columns: [
      { key: "vehicle_plate", label: "Veicolo", type: "plate" },
      { key: "category", label: "Categoria", type: "labelize" },
      { key: "number", label: "Numero" },
      { key: "expiry_date", label: "Scadenza", type: "date" },
      { key: "deadline_status", label: "Stato", type: "deadline", sortValue: (row) => ({ scaduto: 0, in_scadenza: 1, valido: 2, non_valido: 3 }[deadlineSeverity(row.expiry_date).sev]) },
    ],
    fields: [
      { key: "vehicle_id", label: "Veicolo", type: "ref", refType: "vehicles", required: true },
      { key: "category", label: "Categoria", type: "select", required: true, options: opt(["assicurazione", "bollo", "revisione", "leasing", "garanzia", "carta_carburante", "permesso", "altro"]) },
      { key: "number", label: "Numero identificativo", type: "text" },
      { key: "issue_date", label: "Data emissione", type: "date" },
      { key: "expiry_date", label: "Data scadenza", type: "date", required: true },
      { key: "supplier_id", label: "Fornitore / Ente", type: "ref", refType: "suppliers" },
      { key: "cost", label: "Costo", type: "currency" },
      { key: "notes", label: "Note", type: "textarea", full: true },
    ],
  },
  costs: {
    resource: "costs", title: "Costi", icon: Euro,
    description: "Registrazione di tutti i costi della flotta",
    searchKeys: ["vehicle_plate", "category", "description", "payment_method"],
    columns: [
      { key: "date", label: "Data", type: "date" },
      { key: "vehicle_plate", label: "Veicolo", type: "plate" },
      { key: "category", label: "Categoria", type: "labelize" },
      { key: "total", label: "Totale", type: "currency" },
      { key: "payment_method", label: "Pagamento", type: "labelize" },
    ],
    fields: [
      { key: "vehicle_id", label: "Veicolo", type: "ref", refType: "vehicles", required: true },
      { key: "category", label: "Categoria", type: "select", required: true, options: opt(["carburante", "ricarica", "manutenzione", "assicurazione", "bollo", "leasing", "pedaggi", "parcheggi", "lavaggi", "multe", "riparazioni", "altro"]) },
      { key: "date", label: "Data", type: "date", required: true },
      { key: "supplier_id", label: "Fornitore", type: "ref", refType: "suppliers" },
      { key: "net_amount", label: "Importo netto", type: "currency" },
      { key: "vat", label: "IVA", type: "currency" },
      { key: "total", label: "Totale", type: "currency", required: true },
      { key: "payment_method", label: "Metodo pagamento", type: "select", options: opt(["carta_aziendale", "bonifico", "contanti", "carta_carburante"]) },
      { key: "mileage", label: "Chilometraggio", type: "number" },
      { key: "description", label: "Descrizione", type: "text", full: true },
    ],
  },
  refuelings: {
    resource: "refuelings", title: "Rifornimenti", icon: Fuel,
    description: "Carburante e ricariche elettriche",
    searchKeys: ["vehicle_plate", "station", "fuel_card"],
    columns: [
      { key: "date", label: "Data", type: "date" },
      { key: "vehicle_plate", label: "Veicolo", type: "plate" },
      { key: "liters", label: "Litri/kWh" },
      { key: "total", label: "Totale", type: "currency" },
      { key: "station", label: "Stazione" },
    ],
    fields: [
      { key: "vehicle_id", label: "Veicolo", type: "ref", refType: "vehicles", required: true },
      { key: "date", label: "Data", type: "date", required: true },
      { key: "liters", label: "Litri / kWh", type: "number" },
      { key: "unit_price", label: "Prezzo unitario", type: "number" },
      { key: "total", label: "Totale", type: "currency", required: true },
      { key: "cost_id", label: "Costo già registrato (facoltativo)", type: "cost-link", full: true },
      { key: "fuel_level", label: "Livello serbatoio/batteria", type: "text" },
      { key: "mileage", label: "Chilometraggio", type: "number" },
      { key: "station", label: "Stazione di servizio", type: "text" },
      { key: "fuel_card", label: "Carta carburante", type: "text" },
      { key: "description", label: "Note", type: "textarea", full: true },
    ],
  },
  damages: {
    resource: "damages", title: "Danni e sinistri", icon: ShieldAlert,
    description: "Segnalazione danni e gestione sinistri",
    searchKeys: ["vehicle_plate", "type", "place", "driver", "claim_number", "status"],
    columns: [
      { key: "date", label: "Data", type: "date" },
      { key: "vehicle_plate", label: "Veicolo", type: "plate" },
      { key: "type", label: "Tipo", type: "labelize" },
      { key: "severity", label: "Gravità", type: "labelize" },
      { key: "status", label: "Stato", type: "badge" },
    ],
    defaults: { type: "danno", status: "aperto" },
    fields: [
      { section: "Evento", key: "vehicle_id", label: "Veicolo", type: "ref", refType: "vehicles", required: true },
      { key: "type", label: "Tipo", type: "select", options: opt(["danno", "sinistro"]) },
      { key: "date", label: "Data", type: "date", required: true },
      { key: "place", label: "Luogo", type: "text" },
      { key: "driver", label: "Conducente", type: "text" },
      { key: "severity", label: "Gravità", type: "select", options: opt(["lieve", "medio", "grave"]) },
      { key: "description", label: "Descrizione", type: "textarea", full: true },
      { section: "Assicurazione e controparte", key: "counterpart", label: "Controparte", type: "text" },
      { key: "insurance", label: "Assicurazione", type: "text" },
      { key: "claim_number", label: "Numero pratica", type: "text" },
      { section: "Costi e stato della pratica", key: "estimated_cost", label: "Costo stimato", type: "currency" },
      { key: "actual_cost", label: "Costo effettivo", type: "currency" },
      { key: "responsibility", label: "Responsabilità", type: "select", options: opt(["propria", "controparte", "da_definire"]) },
      { key: "status", label: "Stato pratica", type: "select", options: opt(["aperto", "in_gestione", "chiuso"]) },
      { section: "Allegati e note", key: "photos", label: "Fotografie / allegati", type: "photos", full: true },
      { key: "notes", label: "Note", type: "textarea", full: true },
    ],
  },
  fines: {
    resource: "fines", title: "Multe", icon: Receipt,
    description: "Registrazione e gestione delle multe",
    searchKeys: ["vehicle_plate", "type", "place", "driver", "status"],
    columns: [
      { key: "date", label: "Data", type: "date" },
      { key: "vehicle_plate", label: "Veicolo", type: "plate" },
      { key: "type", label: "Tipo", type: "labelize" },
      { key: "amount", label: "Importo", type: "currency" },
      { key: "status", label: "Stato", type: "badge" },
    ],
    defaults: { status: "da_pagare", category: "multa" },
    fields: [
      { key: "vehicle_id", label: "Veicolo", type: "ref", refType: "vehicles", required: true },
      { key: "date", label: "Data", type: "date", required: true },
      { key: "place", label: "Luogo", type: "text" },
      { key: "type", label: "Tipo violazione", type: "select", options: opt(["eccesso_velocità", "divieto_sosta", "ztl", "semaforo", "altro"]) },
      { key: "driver", label: "Conducente", type: "text" },
      { key: "amount", label: "Importo", type: "currency", required: true },
      { key: "deadline_payment", label: "Scadenza pagamento", type: "date" },
      { key: "status", label: "Stato", type: "select", options: opt(["da_pagare", "pagata", "contestata"]) },
      { key: "notes", label: "Note", type: "textarea", full: true },
    ],
  },
  suppliers: {
    resource: "suppliers", title: "Fornitori", icon: Building2,
    description: "Officine, gommisti, assicurazioni e fornitori",
    searchKeys: ["name", "type", "vat", "email"],
    columns: [
      { key: "name", label: "Nome" },
      { key: "type", label: "Tipo", type: "labelize" },
      { key: "vat", label: "P. IVA" },
      { key: "phone", label: "Telefono" },
      { key: "email", label: "Email" },
    ],
    fields: [
      { key: "name", label: "Nome", type: "text", required: true },
      { key: "type", label: "Tipo", type: "select", options: opt(["officina", "gommista", "assicurazione", "concessionaria", "carburante", "carrozzeria", "altro"]) },
      { key: "vat", label: "Partita IVA", type: "text" },
      { key: "phone", label: "Telefono", type: "text" },
      { key: "email", label: "Email", type: "text" },
    ],
  },
};
